'use client'

import { formatCoin, formatDate, formatPrice } from '@polaris/core/utils'
import { useAtomValue } from 'jotai'
import { isAbortedAtom, routeAtom } from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import { ChainImg } from '../ui/chain-img'
import { ListRowImage } from '../ui/list-row'

export const SuccessStep = () => {
  const route = useAtomValue(routeAtom)
  const isAborted = useAtomValue(isAbortedAtom)

  if (!route || !route.destinationChain) {
    return null
  }

  // Note when isAborted is true, this only applies to persisted/historical routes.
  // Newly executed routes display via "recovery-step.tsx:RecoverySuccessStep" instead,
  // which displays more details about what was recovered.
  const asset = isAborted
    ? route.signSteps.find((step) => route.isStepAborted(step.step_number))
        ?.from_token
    : route.OutputAssetMetadata

  const chain = isAborted
    ? route.signSteps.find((step) => route.isStepAborted(step.step_number))
        ?.from_chain
    : route.destinationChain

  // Newly initiated routes don't have a LastUpdated value
  // Revisited routes do.
  const completed = route.LastUpdated ? new Date(route.LastUpdated) : new Date()

  return (
    <li className='flex flex-col justify-center items-center gap-6 min-h-full overflow-hidden py-5'>
      <div className='text-center'>
        <p className='text-success-text font-semibold'>
          {isAborted ? 'Recovery complete' : 'Trade complete'}
        </p>
        <p className='text-secondary text-sm leading-6'>
          {formatDate(completed, undefined, {
            dateStyle: 'medium',
            timeStyle: 'short',
          })}
        </p>
      </div>
      <div className='flex flex-col gap-1 items-center justify-center w-full grow'>
        <div className='relative mb-6'>
          {asset?.logo_img_url && (
            <ListRowImage
              src={asset.logo_img_url}
              width={64}
              height={64}
              className='size-16 rounded-full'
              unoptimized
            />
          )}
          {chain?.chain_img && (
            <div
              className={cn(
                'absolute bottom-0 right-0 border-3 bg-background border-background rounded-[8px] flex items-center justify-center',
              )}
            >
              <ChainImg
                chainImg={chain.chain_img}
                chainName={chain.chain_name}
                chainId={chain.chain_id}
                unoptimized
                size='md'
              />
            </div>
          )}
        </div>
        {!isAborted && (
          <>
            <h6 className='text-primary text-4xl font-serif font-extralight'>
              {formatPrice(route.usdValueAmountOut)}
            </h6>
            <p className='text-secondary'>
              {formatCoin({
                amount: route.AmountOut,
              })}{' '}
              {route.OutputAssetMetadata.ticker}
            </p>
          </>
        )}
      </div>
    </li>
  )
}
